// extracted by mini-css-extract-plugin
export var accordion = "_dt-0";
export var chevron = "_dt-3";
export var closed = "_dt-2";
export var content = "_dt-4";
export var open = "_dt-1";
export var rotate = "_dt-5";